import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { newFetch, GET, POST, PUT } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const Reasons = ({ history }) => {
  const tabs = ['Active', 'Inactive'];
  const [reasons, setReasons] = useState([]);
  const [oldReasons, setOldReasons] = useState([]);
  const [newReasons, setNewReasons] = useState([]);
  const [hideInactive, setHideInactive] = useState(false);

  const fetchReasons = async () => {
    let api_path = `/reward/reason`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let reasonsData = response.data;

      setReasons(reasonsData);
      setOldReasons(JSON.parse(JSON.stringify(reasonsData)));
    }
  };

  const handleUpdateOldReason = (i, e) => {
    let clone = [...oldReasons];
    clone[i].reason = e.target.value;
    setOldReasons(clone);
  };

  const handleUpdateOldPoints = (i, e) => {
    let clone = [...oldReasons];
    clone[i].points = e.target.value;
    setOldReasons(clone);
  };

  const handleUpdateOldActive = (i, e) => {
    let clone = [...oldReasons];
    clone[i].active = !clone[i].active;
    setOldReasons(clone);
  };

  const handleAddNewReason = () => {
    setNewReasons([
      ...newReasons,
      {
        reason: '',
        points: 0,
        active: true,
      },
    ]);
  };

  const handleUpdateNewReason = (i, e) => {
    let clone = [...newReasons];
    clone[i].reason = e.target.value;
    setNewReasons(clone);
  };

  const handleUpdateNewPoints = (i, e) => {
    let clone = [...newReasons];
    clone[i].points = e.target.value;
    setNewReasons(clone);
  };

  const handleUpdateNewActive = (i, e) => {
    let clone = [...newReasons];
    clone[i].active = !clone[i].active;
    setNewReasons(clone);
  };

  const handleDeleteNewReason = (i) =>
    setNewReasons([...newReasons].filter((reason, index) => index !== i));

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard the unsaved changes?'
      )
    ) {
      setOldReasons(reasons);
      setNewReasons([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update the Reward Reasons?'
      )
    ) {
      let api_path = `/reward/reason`;
      // // update old actions
      if (oldReasons.length > 0) {
        let update_data = {
          reasons: oldReasons.map((reason) => ({
            id: reason.id,
            reason: reason.reason,
            points: reason.points,
            active: reason.active,
          })),
        };
        let update_response = await newFetch(PUT, api_path, update_data);

        ToastUtil.success(update_response.message);

        update_response.success &&
          newReasons.length <= 0 &&
          window.location.reload();
      }

      // // create new actions
      if (newReasons.length > 0) {
        let create_data = {
          reasons: newReasons.map((reason) => ({
            reason: reason.reason,
            points: reason.points,
            active: reason.active,
          })),
        };
        let create_response = await newFetch(POST, api_path, create_data);

        ToastUtil.success(create_response.message);
        create_response.success && window.location.reload();
      }
    }
  };

  useEffect(() => {
    fetchReasons();
  }, []);

  return (
    <form onSubmit={(e) => handleSubmit(e)} className="d-flex flex-column">
      <div className="p-4 d-flex flex-column">
        <div className="d-flex justify-content-between mb-4 pb-2">
          <h5>Reward Reasons</h5>
          <div className="form-check">
            <input
              type="checkbox"
              name="hideInactiveCheck"
              id="hideInactiveCheck"
              className="me-2 form-check-input"
              value={hideInactive}
              onChange={() => setHideInactive(!hideInactive)}
            />
            <label className="form-check-label" htmlFor="hideInactiveCheck">
              Hide Inactive?
            </label>
          </div>
        </div>

        <div className="row border-bottom mb-2 pb-2">
          <div className="col-6 fw-bold">Description</div>
          <div className="col-2 fw-bold text-center">Points</div>
          <div className="col-2 fw-bold text-center">Active?</div>
          <div className="col-2 fw-bold text-center">Delete</div>
        </div>
        {oldReasons.map(
          (reason, index) =>
            (!hideInactive || reason.active) && (
              <div key={index} className="row py-2">
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control adjust-fs"
                    value={reason.reason}
                    onChange={(e) => handleUpdateOldReason(index, e)}
                  />
                </div>

                <div className="col-2">
                  <input
                    type="number"
                    className="form-control adjust-fs"
                    value={reason.points}
                    onChange={(e) => handleUpdateOldPoints(index, e)}
                  />
                </div>

                <div
                  className="col-2 text-center"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => handleUpdateOldActive(index, e)}
                >
                  {reason.active ? (
                    <i className="fas fa-check text-success pt-2"></i>
                  ) : (
                    <i className="fas fa-times text-danger pt-2"></i>
                  )}
                </div>
                <div className="col-2"></div>
              </div>
            )
        )}
        {newReasons.map((reason, index) => (
          <div key={index} className="row py-2">
            <div className="col-6">
              <input
                type="text"
                className="form-control adjust-fs"
                value={reason.reason}
                onChange={(e) => handleUpdateNewReason(index, e)}
              />
            </div>

            <div className="col-2">
              <input
                type="number"
                min="0"
                className="form-control adjust-fs"
                value={reason.points}
                onChange={(e) => handleUpdateNewPoints(index, e)}
              />
            </div>

            <div
              className="col-2 text-center"
              style={{ cursor: 'pointer' }}
              onClick={(e) => handleUpdateNewActive(index, e)}
            >
              {reason.active ? (
                <i className="fas fa-check text-success pt-2"></i>
              ) : (
                <i className="fas fa-times text-danger pt-2"></i>
              )}
            </div>

            <div
              className="col-2 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => handleDeleteNewReason(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={() => handleAddNewReason()}
        >
          <i className="fas fa-plus me-2" /> Add New Reason
        </button>
        <div
          style={{
            height: '4.5rem',
          }}
          className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
        >
          <button
            type="button"
            onClick={discardHandler}
            className="btn btn-outline-brand adjust-fs adjust-shadow"
            style={{ width: '12rem' }}
          >
            Discard changes
          </button>
          <button
            type="submit"
            className="btn btn-brand ms-3 adjust-fs adjust-shadow"
            style={{ width: '12rem' }}
          >
            Save changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default withRouter(Reasons);
